export default "__VITE_ASSET__CkqUlf_J__"